/**
* @license Copyright (c) Microsoft Corporation. All rights reserved.
*/
export var PushNotificationEntity;
(function (PushNotificationEntity) {
    PushNotificationEntity.title = "msdynmkt_title";
    PushNotificationEntity.subtitle = "msdynmkt_subtitle";
    PushNotificationEntity.imageId = "msdynmkt_imageid";
    PushNotificationEntity.message = "msdynmkt_message";
    PushNotificationEntity.onClickBehavior = "msdynmkt_onclickbehavior";
    PushNotificationEntity.link = "msdynmkt_link";
    PushNotificationEntity.name = "msdynmkt_name";
    PushNotificationEntity.appName = "msdynmkt_appname";
    PushNotificationEntity.placeholders = "msdynmkt_placeholders";
    PushNotificationEntity.messageDesignation = "msdynmkt_messagedesignation";
    PushNotificationEntity.header_placeholders = "header_msdynmkt_placeholders"; // Its in the header of the form xml, so it has header_ prefix when used from getControl context
    PushNotificationEntity.entityId = "msdynmkt_pushnotificationid";
    PushNotificationEntity.statuscode = "statuscode";
    PushNotificationEntity.entityName = "msdynmkt_pushnotification";
    PushNotificationEntity.entityPluralName = "msdynmkt_pushnotifications";
})(PushNotificationEntity || (PushNotificationEntity = {}));
export var OnClickBehaviorOption;
(function (OnClickBehaviorOption) {
    OnClickBehaviorOption.openApp = 534120000;
    OnClickBehaviorOption.openInBrowser = 534120001;
    OnClickBehaviorOption.openCustomerVoiceSurvey = 534120002;
})(OnClickBehaviorOption || (OnClickBehaviorOption = {}));
export var PushStatus;
(function (PushStatus) {
    PushStatus.draft = 1;
    PushStatus.readyToSend = 2;
})(PushStatus || (PushStatus = {}));
